const projects = () => {
    if ($(".projects").length) {
        $('.item .image').mouseover(function() {
            $(this).parents('.item').find('.group-content').addClass('active');
        });

        $('.item .image').mouseout(function() {
            $(this).parents('.item').find('.group-content').removeClass('active');
        });

        $('.item .group-content').mouseover(function() {
            $(this).parents('.item').find('.image img').addClass('active');
        });

        $('.item .group-content').mouseout(function() {
            $(this).parents('.item').find('.image img').removeClass('active');
        });
    }

    if ($(".project-detail").length) {
        $('.relateds').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            fade: false,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 3000,
            rows: 1,
            slidesPerRow: 3,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        rows: 1,
                        slidesPerRow: 1,
                        infinite: false,
                        slidesToShow: 1.5,
                    }
                }
            ]
        });

        $('.item-related .image').mouseover(function() {
            $(this).parents('.item-related').find('.group-content').addClass('active');
        });

        $('.item-related .group-content').mouseout(function() {
            $(this).parents('.item-related').find('.image img').removeClass('active');
        });

        $('.item-related .group-content').mouseover(function() {
            $(this).parents('.item-related').find('.image img').addClass('active');
        });
    }
}

module.exports = projects
